import DailyPicksWidget from './DailyPicksWidget';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import '../../components/Layout/Layout.css';
import { marketsAPI } from '../../services/api';

const MARKETS = [
  { key: 'india',  label: 'Indian Market', flag: '🇮🇳', index: 'NIFTY 50',  indexSymbol: 'NIFTY50',  color: '#00ff88' },
  { key: 'us',     label: 'US Market',     flag: '🇺🇸', index: 'S&P 500',   indexSymbol: 'SP500',    color: '#00b8ff' },
  { key: 'crypto', label: 'Crypto', flag: '₿', index: 'BTC/USD', indexSymbol: 'BTC', color: '#f7931a' },
  { key: 'global', label: 'Global', flag: '🌍', index: 'FTSE 100', indexSymbol: 'FTSE100', color: '#a855f7' },
];

const DEMO_STOCKS = [
  { symbol: 'RELIANCE', name: 'Reliance Industries', price: '₹2,847', change: '+1.2%', signal: 'BUY',  market: 'india'  },
  { symbol: 'TCS',      name: 'Tata Consultancy',    price: '₹3,421', change: '+0.8%', signal: 'HOLD', market: 'india'  },
  { symbol: 'AAPL',     name: 'Apple Inc.',           price: '$178',   change: '+0.5%', signal: 'BUY',  market: 'us'     },
  { symbol: 'TSLA',     name: 'Tesla Inc.',           price: '$242',   change: '-1.3%', signal: 'SELL', market: 'us'     },
  { symbol: 'BTC',      name: 'Bitcoin',              price: '$67,200',change: '+2.1%', signal: 'BUY',  market: 'crypto' },
];

export default function DashboardPage() {
  const { user } = useSelector(state => state.auth);
  const [time, setTime]   = useState(new Date());
  const [indices, setIndices] = useState({});

  useEffect(() => {
    const fetchIndices = async () => {
      try {
        const { marketsAPI } = await import('../../services/api');
        const [india, us, crypto, global] = await Promise.all([
          marketsAPI.getIndices('india'),
          marketsAPI.getIndices('us'),
          marketsAPI.getIndices('crypto'),
          marketsAPI.getIndices('global'),
        ]);
        const idxMap = {};
        [...(india||[]), ...(us||[]), ...(crypto||[]), ...(global||[])].forEach(idx => {
          idxMap[idx.symbol] = idx;
        });
        setIndices(idxMap);
      } catch(e) { console.error(e); }
    };
    fetchIndices();
    const timer = setInterval(fetchIndices, 60000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const t = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  const greeting = () => {
    const h = time.getHours();
    if (h < 12) return 'Good morning';
    if (h < 17) return 'Good afternoon';
    return 'Good evening';
  };

  return (
    <div className="page">
      <DailyPicksWidget />
      {/* Header */}
      <div className="page-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div>
          <div className="page-title">{greeting()}, {user?.full_name || user?.username}! 👋</div>
          <div className="page-subtitle">
            {time.toLocaleDateString('en-IN', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}
            &nbsp;·&nbsp;
            {time.toLocaleTimeString()}
          </div>
        </div>
        <Link to="/portfolio" className="btn btn-primary">+ Add Trade</Link>
      </div>

      {/* Market Overview */}
      <div style={{ marginBottom: '24px' }}>
        <div className="card-title" style={{ marginBottom: '16px', fontSize: '12px', color: 'rgba(255,255,255,0.3)', letterSpacing: '1px' }}>
          MARKET OVERVIEW
        </div>
        <div className="stats-grid">
          {MARKETS.map(m => (
            <Link key={m.key} to={`/markets/${m.key}`} style={{ textDecoration: 'none' }}>
              <div className="stat-card" style={{ cursor: 'pointer', transition: 'border-color 0.2s', borderColor: 'rgba(255,255,255,0.07)' }}
                onMouseEnter={e => e.currentTarget.style.borderColor = m.color}
                onMouseLeave={e => e.currentTarget.style.borderColor = 'rgba(255,255,255,0.07)'}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                  <span style={{ fontSize: '24px' }}>{m.flag}</span>
                  <span style={{ fontSize: '11px', background: 'rgba(0,255,136,0.1)', color: '#00ff88', padding: '3px 8px', borderRadius: '20px' }}>LIVE</span>
                </div>
                <div className="stat-label">{m.index}</div>
                <div className="stat-value" style={{ fontSize: '20px', color: m.color }}>
                  {indices[m.indexSymbol] ? parseFloat(indices[m.indexSymbol].price).toLocaleString('en-IN', {maximumFractionDigits:2}) : '--'}
                </div>
                <div className={`stat-change ${(indices[m.indexSymbol]?.change_percent||0) >= 0 ? 'up' : 'down'}`}>
                  {indices[m.indexSymbol] ? `${(indices[m.indexSymbol].change_percent||0) >= 0 ? '▲' : '▼'} ${Math.abs(indices[m.indexSymbol].change_percent||0).toFixed(2)}%` : 'Loading...'}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>

      {/* Portfolio Summary + AI Picks */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginBottom: '24px' }}>

        {/* Portfolio Summary */}
        <div className="card">
          <div className="card-title">Portfolio Summary</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            {[
              { label: 'Total Invested', value: '₹0.00', sub: 'Across all markets' },
              { label: 'Current Value',  value: '₹0.00', sub: '0 holdings' },
              { label: 'Total P&L',      value: '₹0.00', sub: '0.00%', color: '#00ff88' },
            ].map((item, i) => (
              <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 0', borderBottom: i < 2 ? '1px solid rgba(255,255,255,0.05)' : 'none' }}>
                <div>
                  <div style={{ fontSize: '13px', color: 'rgba(255,255,255,0.4)' }}>{item.label}</div>
                  <div style={{ fontSize: '11px', color: 'rgba(255,255,255,0.2)', marginTop: '2px' }}>{item.sub}</div>
                </div>
                <div style={{ fontSize: '18px', fontWeight: '700', color: item.color || '#ffffff', fontFamily: 'Syne, sans-serif' }}>{item.value}</div>
              </div>
            ))}
            <Link to="/portfolio" className="btn btn-outline" style={{ textAlign: 'center', textDecoration: 'none', display: 'block' }}>
              View Portfolio →
            </Link>
          </div>
        </div>

        {/* AI Signal Summary */}
        <div className="card">
          <div className="card-title">AI Signal Summary</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {[
              { market: '🇮🇳 India',  signal: 'BULLISH', confidence: '78%', color: '#00ff88' },
              { market: '🇺🇸 US',     signal: 'NEUTRAL', confidence: '61%', color: '#ffb800' },
              { market: '₿ Crypto',   signal: 'BULLISH', confidence: '82%', color: '#00ff88' },
              { market: '🌍 Global',  signal: 'BEARISH', confidence: '54%', color: '#ff4d4d' },
            ].map((item, i) => (
              <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 14px', background: 'rgba(255,255,255,0.03)', borderRadius: '10px' }}>
                <span style={{ fontSize: '14px', color: 'rgba(255,255,255,0.7)' }}>{item.market}</span>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <span style={{ fontSize: '12px', color: 'rgba(255,255,255,0.3)' }}>{item.confidence}</span>
                  <span style={{ fontSize: '12px', fontWeight: '700', color: item.color, background: `${item.color}18`, padding: '3px 10px', borderRadius: '20px' }}>{item.signal}</span>
                </div>
              </div>
            ))}
            <Link to="/predictions" className="btn btn-outline" style={{ textAlign: 'center', textDecoration: 'none', display: 'block' }}>
              View All Predictions →
            </Link>
          </div>
        </div>
      </div>

      {/* Top Stock Picks */}
      <div className="card">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
          <div className="card-title" style={{ margin: 0 }}>AI Stock Picks Today</div>
          <Link to="/predictions" style={{ fontSize: '13px', color: '#00ff88', textDecoration: 'none' }}>View all →</Link>
        </div>
        <div className="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>Stock</th>
                <th>Market</th>
                <th>Price</th>
                <th>Change</th>
                <th>AI Signal</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {DEMO_STOCKS.map((stock, i) => (
                <tr key={i}>
                  <td>
                    <div style={{ fontWeight: '600', color: '#ffffff' }}>{stock.symbol}</div>
                    <div style={{ fontSize: '12px', color: 'rgba(255,255,255,0.3)' }}>{stock.name}</div>
                  </td>
                  <td>
                    <span style={{ fontSize: '12px', color: 'rgba(255,255,255,0.4)', textTransform: 'capitalize' }}>
                      {stock.market}
                    </span>
                  </td>
                  <td style={{ fontWeight: '600' }}>{stock.price}</td>
                  <td>
                    <span style={{ color: stock.change.startsWith('+') ? '#00ff88' : '#ff4d4d' }}>
                      {stock.change}
                    </span>
                  </td>
                  <td>
                    <span className={`badge badge-${stock.signal.toLowerCase()}`}>{stock.signal}</span>
                  </td>
                  <td>
                    <button className="btn btn-outline" style={{ padding: '6px 14px', fontSize: '12px' }}>
                      + Add
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
